import { render, staticRenderFns } from "./competitional-argue.vue?vue&type=template&id=c950831e&scoped=true"
import script from "./competitional-argue.vue?vue&type=script&lang=js"
export * from "./competitional-argue.vue?vue&type=script&lang=js"
import style0 from "./competitional-argue.vue?vue&type=style&index=0&id=c950831e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950831e",
  null
  
)

export default component.exports